import React from "react";
import { Dialog, DialogTitle, DialogActions } from "@mui/material";
import ActionButton from "./ActionButton";

const DeleteProjectModal = ({ open, onClose, onConfirm, project }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        Are you sure you want to delete project "{project?.title}"?
      </DialogTitle>
      <DialogActions>
        <ActionButton onClick={onClose} tone="ghost">
          Cancel
        </ActionButton>
        
        <ActionButton onClick={onConfirm} tone="danger">
          Delete
        </ActionButton>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteProjectModal;
